const mobileMenu = document.querySelector('.mobile-menu');
const openButton = document.querySelector('.mobile-menu-open');
const closeButton = document.querySelector('.mobile-menu-close');
const navItems = document.querySelectorAll('.mobile-menu__nav .nav__item');

export const openMenu = () => {
  mobileMenu.classList.add('active');
  document.body.style.overflow = 'hidden';
};

export const closeMenu = () => {
  mobileMenu.classList.remove('active');
  document.body.style.overflow = '';
};

openButton.addEventListener('click', openMenu);
closeButton.addEventListener('click', closeMenu);

navItems.forEach(item => {
  item.addEventListener('click', closeMenu);
});
